// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__35pIT","obliqueLineWrap":"membershipbadge_obliqueLineWrap__hlIkL","obliqueLine":"membershipbadge_obliqueLine__2EsVf"};